<!-- {{form.value | json}} -->
<div [formGroup]="form" class="row">
    <div *ngFor="let filter of filters" class="col-lg-2 col-sm-6 my-2 filter-field">
        <div [ngSwitch]="filter.controlType">

            <input [id]="filter.key" *ngSwitchCase="'textbox'" type="text" [formControlName]="filter.key"
                class="form-control form-control-sm" [placeholder]="filter.label" style="height: 31px;" />

            <!-- radio -->
            <div *ngSwitchCase="'radio'" class="radio-filter d-flex align-items-center">
                <label class="radio-filter-label mb-0 me-2">{{filter.label}}</label>
                <div class="form-check form-check-inline mb-0" *ngFor="let opt of filter.options">
                    <input class="form-check-input" type="radio" [id]="filter.key + '_' + opt.id"
                        [value]="opt.id" [formControlName]="filter.key" (click)="onRadioClick(filter, opt.id)" />
                    <label class="form-check-label" [for]="filter.key + '_' + opt.id">{{opt.displayText}}</label>
                </div>
            </div>

            <!-- lookupdropdown -->
            <ng-select *ngSwitchCase="'lookupdropdown'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
            
            <!-- globalRank -->
            <ng-select *ngSwitchCase="'globalRank'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="rankName" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="rankCode" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.rankName}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>

            <!-- locationdropdownBasedonEmployee -->
            <ng-select *ngSwitchCase="'locationdropdownBasedonEmployee'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>


            <!--CountryOfficeLocationWithConsultantChange-->
            <ng-select *ngSwitchCase="'CountryOfficeLocationWithConsultantChange'" [placeholder]="filter.label"
                [items]="filter.options" class="filter-dropdown" [multiple]="true" bindLabel="displayText"
                [selectableGroup]="false" [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key"
                (change)="updateVisaApproversAccordingToOfficeLocation($event)">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
            <!-- empdropdown -->
            <ng-select *ngSwitchCase="'empdropdown'" [placeholder]="filter.label" [items]="employeesInOfficeLe"
                class="filter-dropdown" [multiple]="true" bindLabel="name" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.name}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
            <ng-select *ngSwitchCase="'LocationBasedEmpDropDown'" [placeholder]="filter.label"
                [items]="employeesInOfficeLe" class="filter-dropdown" [multiple]="true" bindLabel="name"
                [selectableGroup]="false" [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.name}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
            <!-- visaApproverDropdown -->
            <ng-select *ngSwitchCase="'visaApproverDropdown'" [placeholder]="filter.label"
                [items]="employeesInOfficeLe" class="filter-dropdown" [multiple]="true" bindLabel="name"
                [selectableGroup]="false" [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.name}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
            <!-- serviceLine -->
            <ng-select *ngSwitchCase="'serviceLine'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>


            <!-- subServiceLine -->
            <ng-select *ngSwitchCase="'subServiceLine'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>

            <!-- officeLe -->
            <ng-select *ngSwitchCase="'officeLe'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key"
                (change)="updateVisaApprovers($event)">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>

            <ng-select *ngSwitchCase="'OfficeLeWithoutConnectedFilters'" [placeholder]="filter.label"
                [items]="filter.options" class="filter-dropdown" [multiple]="true" bindLabel="displayText"
                [selectableGroup]="false" [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
            <!-- Exti emplooyee drop dwon -->
            <ng-select *ngSwitchCase="'exitEmpDropdown'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="name" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.name}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>

             <!-- exitTypeDropdown -->
             <ng-select *ngSwitchCase="'exitTypeDropdown'" [placeholder]="filter.label" [items]="filter.options"
             class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
             [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
             <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                 <div class="ng-value" *ngFor="let item of items | slice:0:1">
                     <span class="ng-value-label">
                         {{item.displayText}}</span>
                     <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                 </div>
                 <div class="ng-value" *ngIf="items.length > 1">
                     <span class="ng-value-label">+{{items.length - 1}}</span>
                 </div>
             </ng-template>
         </ng-select>

<div *ngSwitchCase="'dateRangePicker'" class="input-group align-items-center date-picker-custom">

    <!-- Date display -->
    <div class="form-control form-control-sm calendar" style="height: 33px; padding: 8px; cursor: pointer;"
        (click)="openMod()">
        <span *ngIf="form.value.submissionstartDate || form.value.submissionendDate">
                        {{form.value.submissionstartDate | date:'dd-MMM-yy'}} -
                        {{form.value.submissionendDate | date:'dd-MMM-yy'}}
        </span>

        <span *ngIf="!form.value.submissionstartDate && !form.value.submissionendDate">
            Submission date
        </span>
    </div>

    <!-- Clear (remove) button -->
    <button type="button" class="btn p-0 bg-transparent d-flex align-items-center rmv-btn" (click)="clearDate()">
        <img src="design/images/close-dark.png" class="ms-1 me-2 dark"
            style="width: 10px; height: 10px; object-fit: contain; vertical-align: middle;" alt="remove">
        <img src="design/images/close-light.png" class="ms-1 me-2 light"
            style="width: 10px; height: 10px; object-fit: contain; vertical-align: middle;" alt="remove">
    </button>

    <!-- Calendar icon (opens modal) -->
    <button type="button" class="btn p-0 bg-transparent d-flex align-items-center" (click)="openMod()">
        <img src="design/images/calendar.png" style="width: 16px; height: 16px; object-fit: contain;"
            alt="calendar icon">
    </button>

</div>

            <div *ngSwitchCase="'dateRangePickerReusable'" class="input-group date-picker-custom">
                <!-- <input [id]="filter.key" name="range" type="text" [placeholder]="filter.label" [(ngModel)]=""
                    readonly > -->
                <div class="form-control form-control-sm calendar" style="height: 32px; padding: 8px;"
                    (click)="openExitDateMod()">

                    <span *ngIf="form.value.exitDateLowerBound || form.value.exitDateUpperBound">
                        {{form.value.exitDateLowerBound | date:'dd-MMM-yy'}} -
                        {{form.value.exitDateUpperBound | date:'dd-MMM-yy'}}
                    </span>

                    <span *ngIf="!form.value.exitDateLowerBound && !form.value.exitDateUpperBound">
                        Exit date
                    </span>


                </div>
                <button class="input-group-append align-items-center bg-transparent rmv-btn" (click)=" clearexitDate()">
                    <img src="design/images/close-dark.png" class="ms-1 me-2 dark" style="width: 10px;height:10px"
                        alt="remove">
                    <img src="design/images/close-light.png" class="ms-1 me-2 light" style="width: 10px;height:10px"
                        alt="remove">
                </button>
                <div class="input-group-append">
                    <img src="design/images/calendar.png" (click)="openExitDateMod()" />
                </div>
            </div>
                        <!-- governanceEmployeeLocation -->
            <ng-select *ngSwitchCase="'governanceEmployeeLocation'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">{{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>

            <!-- governanceCountry -->
            <ng-select *ngSwitchCase="'governanceCountry'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">{{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>

            <!-- governanceEmployeeLegalEntity -->
            <ng-select *ngSwitchCase="'governanceEmployeeLegalEntity'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">{{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
                        <!-- governanceDocumentType -->
            <ng-select *ngSwitchCase="'governanceDocumentType'" [placeholder]="filter.label" [items]="filter.options"
                class="filter-dropdown" [multiple]="true" bindLabel="displayText" [selectableGroup]="false"
                [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">{{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
                        <!-- governanceProcessOwnerDropdown -->
            <ng-select *ngSwitchCase="'governanceProcessOwnerDropdown'" [placeholder]="filter.label"
                [items]="filter.options" class="filter-dropdown" [multiple]="true" bindLabel="displayText"
                [selectableGroup]="false" [closeOnSelect]="false" bindValue="id" [formControlName]="filter.key">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                            {{item.displayText}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 1">
                        <span class="ng-value-label">+{{items.length - 1}}</span>
                    </div>
                </ng-template>
            </ng-select>
                        <div *ngSwitchCase="'governanceExpiryDatePicker'" class="input-group date-picker-custom">
                <div class="form-control form-control-sm calendar" style="height: 32px; padding: 8px;"
                    (click)="openExpiryDateMod()">

                    <span *ngIf="form.value.expiryStartDate || form.value.expiryEndDate">
                        {{form.value.expiryStartDate | date:'dd-MMM-yy'}} -
                        {{form.value.expiryEndDate | date:'dd-MMM-yy'}}
                    </span>

                    <span *ngIf="!form.value.expiryStartDate && !form.value.expiryEndDate">
                        Expiry Date
                    </span>

                </div>
                <button type="button" class="btn p-0 bg-transparent d-flex align-items-center rmv-btn" (click)="clearExpiryDate()">
                    <img src="design/images/close-dark.png" class="ms-1 me-2 dark"
                        style="width: 10px; height: 10px; object-fit: contain; vertical-align: middle;" alt="remove">
                    <img src="design/images/close-light.png" class="ms-1 me-2 light"
                        style="width: 10px; height: 10px; object-fit: contain; vertical-align: middle;" alt="remove">
                </button>
                <button type="button" class="btn p-0 bg-transparent d-flex align-items-center" (click)="openExpiryDateMod()">
                    <img src="design/images/calendar.png" style="width: 16px; height: 16px; object-fit: contain;"
                        alt="calendar icon">
                </button>
            </div>
        </div>
    </div>

    <!-- {{form.value | json}} -->
</div>
